module.exports = __webpack_public_path__ + "img/dog.90994727.svg";